<div class="d-flex flex-column" style="width: 100%">
  <!-- Top module title header container -->
  <div class="sb-header">Main Menu</div>
  
  <!-- Main scrolling navigational panel element list -->
  <div class="sb-list" id="setBox">
    <ng-container *ngFor="let item of mainmenu; let i = index">
      
      <div *ngIf="item.type === 'standalone'"
           (click)="!item.locked && navigateUrl(item.url)"
           class="sitem"
           [class.active]="!item.locked && isUrlMatch(item)"
           [class.locked]="item.locked">
        <span class="item-name">{{ item.name }}</span>
        <mat-icon *ngIf="item.locked" class="lock-icon">lock</mat-icon>
      </div>

      <div *ngIf="item.type !== 'standalone'" 
           class="sgroup" 
           [class.open]="activeGroupIndex === i">
        
        <!-- Toggle header strip area -->
        <div class="sg-hd" (click)="toggleGroup(i)" [class.locked]="item.locked">
          <span class="item-name">{{ item.name }}</span>
          <mat-icon *ngIf="item.locked" class="lock-icon">lock</mat-icon>
          <span class="sg-arr" *ngIf="!item.locked">
            <mat-icon>expand_more</mat-icon>
          </span>
        </div>
        
        <!-- Nested explicit target routing child collection -->
        <div class="sg-kids">
          <div *ngFor="let child of item.children" 
               (click)="!item.locked && navigateUrl(child.url)"
               class="skid" 
               [class.active]="isUrlMatch(child)">
            {{ child.name }}
          </div>
        </div>

      </div>

    </ng-container>
  </div>
</div>